<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Kefwxh/tc-custom/9781452152752.jpg?1700253325841" alt="This image is the cover for the book Happiness Is . . . 500 Ways to Be in the Moment"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Happiness Is . . . 500 Ways to Be in the Moment
      </h1>
      <p class="bookDescription body article font2">
        <b>Mindful living is happy living. Discover five hundred ways to notice—and embrace—the best moments in life.</b><br/><br/>This refreshing book from the creators of <i>Happiness Is. . . . </i>illustrates five hundred inspiring ways to slow down, unplug, de-stress, connect with others, and relish the simple moments in life: sitting under a ceiling fan on a hot day, taking lunch away from your desk, letting go of negative thoughts, a beach yoga session, and more. <br/><br/>Featuring charming illustrations and a friendly tone, this book sparks positive reflection and serves to remind us that happiness is all around—and within.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Swerling, Ralph Lazar
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e1028a7